import type { PaginaPublica } from '../../types/contenido-publico';

interface PageSelectorProps {
  value: PaginaPublica;
  onChange: (value: PaginaPublica) => void;
  counts?: Partial<Record<PaginaPublica, number>>;
}

const PAGINAS: { value: PaginaPublica; label: string }[] = [
  { value: 'INICIO', label: 'Inicio' },
  { value: 'NOSOTROS', label: 'Nosotros' },
  { value: 'EVENTOS', label: 'Eventos' },
  { value: 'CONTACTO', label: 'Contacto' },
  { value: 'DONACIONES', label: 'Donaciones' },
  { value: 'FUNDACION', label: 'Fundación' },
  { value: 'IGLESIA', label: 'Iglesia' },
  { value: 'HEADER', label: 'Header' },
  { value: 'FOOTER', label: 'Footer' },
];

export const PageSelector: React.FC<PageSelectorProps> = ({ value, onChange, counts }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {PAGINAS.map((pagina) => {
        const isActive = value === pagina.value;
        const count = counts?.[pagina.value];
        return (
          <button
            key={pagina.value}
            onClick={() => onChange(pagina.value)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${
              isActive
                ? 'bg-purple-600 text-white'
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-purple-50'
            }`}
          >
            {pagina.label}
            {count !== undefined && (
              <span
                className={`text-[10px] px-1.5 py-0.5 rounded-full font-semibold ${
                  isActive ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-500'
                }`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
